import { useRef, useState } from "react";
import { Button, Popover, Tooltip, Typography } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { t } from "i18next";
import ApiService from "../../../core/service/api-service";
import InstitutionSelect from "../../user/InstitutionSelect";
import "./institution-cell.css";

/**
 * Kurum hücresi — masaüstü kolonu ve mobil kart aynı bileşeni kullanır.
 *
 * Düzenlenebilir hâli GERÇEK BİR BUTON: eskiden <a> sarılı düz metindi ve tıklanabilir olduğu
 * anlaşılmıyordu (kurum adının kendisi de metin olduğu için link mi veri mi belli olmuyordu).
 * Buton + karet, hücrenin bir açılır seçim tetiklediğini kendi başına anlatır.
 *
 * @param label   Başına yazılacak etiket (mobil kartta "Kurum:"; masaüstünde kolon başlığı zaten var).
 * @param inBody  Popover'ı document.body'ye bağla (mobil kart taşma/kırpılma yaşıyordu).
 */
export default function InstitutionCell({ record, canEdit, onChanged, label, inBody })
{
    const text = record.institution || '-';
    const btnTextRef = useRef(null);
    const [tooltipOpen, setTooltipOpen] = useState(false);

    if (!canEdit) {
        return (
            // Tooltip yalnız metin gerçekten kesildiğinde çıkar (antd ellipsis ölçer).
            <Typography.Text
                ellipsis={{ tooltip: { title: text, mouseEnterDelay: 0.6 } }}
                className="institution-cell-text"
            >
                {label ? `${label}: ${text}` : text}
            </Typography.Text>
        );
    }

    // Butondaki ad CSS ile kesiliyor: tooltip açılacağı an ölçülür, ad sığıyorsa hiç açılmaz.
    const onTooltipOpenChange = (open) => {
        const el = btnTextRef.current;
        setTooltipOpen(open && !!el && el.scrollWidth > el.clientWidth);
    };

    return (
        <Popover
            trigger={'click'}
            placement={'bottom'}
            getPopupContainer={inBody ? () => document.body : undefined}
            content={(
                // Popover içeriği portal ile taşınsa da olaylar React ağacında yukarı akar;
                // durdurulmazsa seçim yaparken satır seçiliyor / mobil kart açılıp kapanıyor.
                <div onClick={(e) => e.stopPropagation()}>
                    <InstitutionSelect
                        value={record.institutionId}
                        size={'small'}
                        style={{ width: 150 }}
                        placeholder={record.institution}
                        allowClear={true}
                        showSearch={true}
                        mode={'single'}
                        onChange={async (val) => {
                            const res = await ApiService.Study.EditInstitutions(record.id, val);
                            if (res.success) {
                                onChanged && onChanged();
                            }
                        }} />
                </div>
            )}
        >
            <Tooltip
                mouseEnterDelay={0.6}
                title={text}
                open={tooltipOpen}
                onOpenChange={onTooltipOpenChange}
            >
                <Button
                    size={'small'}
                    className="institution-cell-btn"
                    // Buton kendi işini yapar; satır seçimini/kart açılışını da tetiklememeli.
                    onClick={(e) => e.stopPropagation()}
                >
                    <span ref={btnTextRef} className="institution-cell-btn-text">
                        {label ? `${label}: ${text}` : text}
                    </span>
                    <DownOutlined className="institution-cell-btn-caret" />
                </Button>
            </Tooltip>
        </Popover>
    );
}
